import type { TFunction } from 'i18next';
import type { ApiError } from '@/lib/api';

/** Maps the locum-pay API's stable error codes to actionable staff guidance. */
export function locumPayErrorMessage(error: ApiError, t: TFunction): string {
  switch (error.code) {
    case 'ATTENDANCE_CORRECTION_REQUIRED':
      return t('locumPay.errors.attendanceCorrectionRequired');
    case 'LOCUM_PAY_NOT_APPROVED':
      return t('locumPay.errors.notApproved');
    case 'BANK_REFERENCE_REQUIRED':
      return t('locumPay.errors.bankReferenceRequired');
    case 'LOCUM_PAY_NOT_FOUND':
      return t('locumPay.errors.notFound');
    default:
      return error.message;
  }
}
